import { render } from "./TreeNode.vue?vue&type=template&id=ae2bf3dc&scoped=true&ts=true"
import script from "./TreeNode.vue?vue&type=script&lang=ts"
export * from "./TreeNode.vue?vue&type=script&lang=ts"

import "./TreeNode.vue?vue&type=style&index=0&id=ae2bf3dc&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2bf3dc"]])

export default __exports__